
<template >
  <!-- eslint-disable max-len -->
  <div class="bg-yellow-100 p-4 rounded-lg text-yellow-700 text-sm">
    <p>The pension can be reversionary to a child on the death of {{ selectedMember }}.  However, the trustee will only be able to honour this agreement if, at the time of the pensioner's death, the child is:</p>
    <ul class="mt-2 ml-8  list-disc">
      <li>under 18 or</li>
      <li>between 18 and 25 and still financially dependent on the pensioner or</li>
      <li>suffering from a disability that meets certain conditions.</li>
    </ul>
    <p class="mt-4">If the child meets these conditions and does start to receive a reversionary pension on their parent's death:</p>
    <ul class="mt-2 ml-8 list-disc">
      <li>the pension will count towards a special Transfer Balance Account created for the child - it will not necessarily be within the Transfer Balance Cap just because it was within  the parent's Transfer Balance Cap</li>
      <li>the pension will have to be fully commuted and paid out of superannuation when the child reaches age 25 unless he or she is suffering from a disability that meets certain conditions.</li>
    </ul>
  </div>
  <!-- eslint-enable max-len -->
</template>
<script>
export default {
  name: 'warning-under-25',
  props: {
    selectedMember: {
      type: String,
      required: true,
    },
  },
};
</script>
